import { Component, OnInit } from '@angular/core';
import { CompanySummary, SuperAdminService } from '../services.service';


@Component({
  selector: 'app-superadmin-companies',
  templateUrl: './superadmin-companies.component.html',
  styleUrls: ['./superadmin-companies.component.css']
})
export class SuperadminCompaniesComponent implements OnInit {

  companies: CompanySummary[] = [];
  filtered:  CompanySummary[] = [];
  pagedCompanies: CompanySummary[] = [];

  loading = true;
  acting  = false;

  searchQuery  = '';
  statusFilter: 'all' | 'active' | 'suspended' = 'all';

  // Confirm modal
  confirmAction:  'suspend' | 'reactivate' | null = null;
  confirmCompany: CompanySummary | null = null;

  // Pagination
  currentPage  = 1;
  pageSize     = 12;
  totalPages   = 1;
  pageNumbers: number[] = [];

  Math = Math;

  constructor(private superAdminService: SuperAdminService) {}

  ngOnInit(): void {
    this.loadCompanies();
  }

  loadCompanies(): void {
    this.loading = true;
    this.superAdminService.getCompanies().subscribe({
      next: data => {
        this.companies = data;
        this.applyFilter();
        this.loading   = false;
      },
      error: () => { this.loading = false; }
    });
  }

  // ── Filters ───────────────────────────────────────────────

  applyFilter(): void {
    let result = [...this.companies];

    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      result = result.filter(c => c.name.toLowerCase().includes(q));
    }

    if (this.statusFilter === 'active') {
      result = result.filter(c => c.isActive);
    } else if (this.statusFilter === 'suspended') {
      result = result.filter(c => !c.isActive);
    }

    this.filtered    = result;
    this.currentPage = 1;
    this.buildPagination();
    this.updatePage();
  }

  // ── Pagination ────────────────────────────────────────────

  buildPagination(): void {
    this.totalPages  = Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
    this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1)
      .filter(p => Math.abs(p - this.currentPage) <= 2);
  }

  updatePage(): void {
    const start         = (this.currentPage - 1) * this.pageSize;
    this.pagedCompanies = this.filtered.slice(start, start + this.pageSize);
    this.buildPagination();
  }

  goToPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updatePage();
  }

  // ── Summary getters ───────────────────────────────────────

  get activeCount(): number {
    return this.companies.filter(c => c.isActive).length;
  }

  get suspendedCount(): number {
    return this.companies.filter(c => !c.isActive).length;
  }

  // ── Confirm modal ─────────────────────────────────────────

  openConfirm(company: CompanySummary, action: 'suspend' | 'reactivate'): void {
    this.confirmCompany = company;
    this.confirmAction  = action;
  }

  closeConfirm(): void {
    this.confirmAction  = null;
    this.confirmCompany = null;
  }

  executeAction(): void {
    if (!this.confirmCompany || !this.confirmAction) return;

    this.acting = true;
    const id    = this.confirmCompany.id;

    const call = this.confirmAction === 'suspend'
      ? this.superAdminService.suspendCompany(id)
      : this.superAdminService.reactivateCompany(id);

    call.subscribe({
      next: () => {
        // Update local state immediately — no need to reload
        const company = this.companies.find(c => c.id === id);
        if (company) company.isActive = this.confirmAction === 'reactivate';

        this.acting = false;
        this.closeConfirm();
        this.applyFilter();
      },
      error: () => { this.acting = false; }
    });
  }
}